import { combineReducers } from "redux";

import balance from "./balance";
import bill from "./bill";
import lot from "./lot";
import set from "./set";
import tracking from "./tracking";
import transfer from "./transfer";

export default combineReducers({
  lot,
  set,
  balance,
  transfer,
  bill,
  tracking,
});
